/**
 * @file ISO 8601 duration constants.
 */

/**
 * Supported duration codes for the DayJS plugin.
 */
const Durations = {
  YEARS: 'y',
  WEEKS: 'w',
  DAYS: 'd',
  HOURS: 'h',
  MINUTES: 'm',
  SECONDS: 's',
};

export default Durations;
